/*
 * @Autor: lh
 * @Date: 2022-06-28 10:56:29
 * @LastEditors: lh
 * @LastEditTime: 2023-03-11 14:32:46
 * @Description:
 */
import { apiPost, apiGet, axiosPost, axiosGet } from "@/static/js/request";

// "/api/ad/advert/getCredit"
export function adAdvertGetCredit(params) {
  return apiPost({
    url: "/api/ad/advert/getCredit",
    params
  });
}
// 视频广告得会员回调
// "/api/ad/vip/submit"
export function adVipSubmit(params) {
  return apiPost({
    url: "/api/ad/vip/submit",
    params
  });
}
// 视频广告会员获取会员点
// "/api/ad/vip/submit"

// 获取系统播报列表
// "/api/broadcast/list"
export function broadcastList(params) {
  return apiGet({
    url: "/api/broadcast/list",
    params
  });
}
// 发起发送红包请求
// "/api/red/bag/anchor"
export function redBagAnchor(params) {
  return apiGet({
    url: "/api/red/bag/anchor",
    params
  });
}
// "/api/red/bag/anchor/receive"
// 领取主播红包
export function redBagAnchorReceive(params) {
  return apiGet({
    url: "/api/red/bag/anchor/receive",
    params
  });
}

// "/api/red/bag/official"
// 获取关注公众号数据
export function redBagOfficial(params) {
  return apiGet({
    url: "/api/red/bag/official",
    params
  });
}
// "/api/red/bag/level/config"
// 获取等级红包配置
export function redBagLevelConfig(params) {
  return apiGet({
    url: "/api/red/bag/level/config",
    params
  });
}
// "/api/red/bag/level"
// 领取红包
export function getRedBagLevel(params, isNew = false) {
  if (isNew) {
    return axiosGet({
      url: "/api/red/bag/level",
      params
    });
  } else {
    return apiGet({
      url: "/api/red/bag/level",
      params
    });
  }
}
// "/api/red/bag/official/post"
// 兑换码
export function redBagOfficialPost(params) {
  return apiPost({
    url: "/api/red/bag/official/post",
    params
  });
}
// "/api/red/bag/task/config"
// 初始化任务红包面板
export function redBagTaskConfig(params) {
  return apiGet({
    url: "/api/red/bag/task/config",
    params
  });
}
// "/api/red/bag/download/daw"
// 兑换码
export function redBagDownloadDaw(params) {
  return apiPost({
    url: "/api/red/bag/download/daw",
    params
  });
}
// "/api/box/wallet/info"
// 获取游戏盒子钱包数据（积分信息）
export function getBoxWalletInfo(params) {
  return apiGet({
    url: "/api/box/wallet/info",
    params
  });
}
// "/api/box/mall/list"
// 获取随机红包列表
export function getBoxMallList(params) {
  return apiGet({
    url: "/api/box/mall/list",
    params
  });
}
// "/api/box/mall/exchange"
// 领取随机红包
export function postBoxMallExchange(params) {
  return apiPost({
    url: "/api/box/mall/exchange",
    params
  });
}
// "/api/box/wechat/miniprogram/scheme"
//  获取跳转小程序信息
export function getBoxWechatMiniprogram(params) {
  return apiGet({
    url: "/api/box/wechat/miniprogram/scheme",
    params
  });
}
// "/api/rebate/game/recharge/first"
// 获取天剑奇缘首充状态(获取游戏首充状态信息)
export function rebateGameRechargeFirst(params) {
  return apiGet({
    url: "/api/rebate/game/recharge/first",
    params
  });
}
// "/api/rebate/game/recharge/first"
// 领取天剑奇缘首充积分(领取游戏首充积分和现金)
export function rebateGameRechargeFirstPost(params) {
  return apiPost({
    url: "/api/rebate/game/recharge/first",
    params
  });
}
// "/api/vip/v2"
//获取会员数据
export function getVipV2(params) {
  return apiGet({
    url: "/api/vip/v2",
    params
  });
}
// "/api/vip/buy"
// 确认支付
export function vipBuyPost(params) {
  return apiPost({
    url: "/api/vip/buy",
    params
  });
}
// "/api/ad/advert/isAd"
// 视频广告配置
export function adAdvertIsAd(params) {
  return apiGet({
    url: "/api/ad/advert/isAd",
    params
  });
}
// "/api/recharge/order"
// 查询订单信息(判断会员支付状态)
export function rechargeOrder(params) {
  return apiGet({
    url: "/api/recharge/order",
    params
  });
}
// "/api/red/bag/level/money"
// 等级红包领取
export function redBagLevelMoney(params) {
  return apiGet({
    url: "/api/red/bag/level/money",
    params
  });
}
// "/api/ad/vip/data"
// 视频广告获取会员配置信息
export function adVipData(params) {
  return apiGet({
    url: "/api/ad/vip/data",
    params
  });
}
// "/api/diy/tianjian/levelbonus"
// 天剑奇缘红包瓜分信息获取
export function diyTianjianLevelbonus(params) {
  return apiGet({
    url: "/api/diy/tianjian/levelbonus",
    params
  });
}
// "/api/diy/tianjian/levelbonus"
// 领取天剑奇缘瓜分
export function diyTianjianLevelbonusPost(params) {
  return apiPost({
    url: "/api/diy/tianjian/levelbonus",
    params
  });
}

// "/api/red/bag/random"
// 领取随机红包
export function redBagRandom(params) {
  return apiGet({
    url: "/api/red/bag/random",
    params
  });
}
// "/api/diy/sanguo/rechargecard"
// 获取真充卡红包
export function diySanguoRechargecard(params) {
  return apiGet({
    url: "/api/diy/sanguo/rechargecard",
    params
  });
}
// "/api/diy/sanguo/rechargecard"
// 获取真充卡红包 post
export function diySanguoRechargecardPost(params) {
  return apiPost({
    url: "/api/diy/sanguo/rechargecard",
    params
  });
}
// "/api/red/bag/game/level/income"
//获取红包瓜分
export function redBagGameLevelIncome(params) {
  return axiosGet({
    url: "/api/red/bag/game/level/income",
    params
  });
}
// "/api/red/bag/game/level/income" post
//领取红包瓜分
export function redBagGameLevelIncomePost(params) {
  return axiosPost({
    url: "/api/red/bag/game/level/income",
    params
  });
}
// "/api/red/bag/game/play/task"
// 获取游戏玩法红包任务列表
export function redBagGamePlayTask(params, isNew = false) {
  if (isNew) {
    return axiosPost({
      url: "/api/red/bag/game/play/task",
      params
    });
  } else {
    return apiGet({
      url: "/api/red/bag/game/play/task",
      params
    });
  }
}
// "/api/red/bag/task"
// 领取等级红包
export function redBagTask(params) {
  return apiPost({
    url: "/api/red/bag/task",
    params
  });
}
// /api/red/bag/game/level/divide
// 获取新版瓜分红包配置
export function getGameLevelDivide(params) {
  return axiosGet({
    url: "/api/red/bag/game/level/divide",
    params
  });
}
// /api/red/bag/game/level/divide/receive
// 获取新版瓜分红包配置
export function receiveGameLevelDivide(params) {
  return apiPost({
    url: "/api/red/bag/game/level/divide/receive",
    params
  });
}
// /api/red/bag/game/level/divide/log
// 获取瓜分红包日志
export function getGameLevelDivideLog(params) {
  return axiosGet({
    url: "/api/red/bag/game/level/divide/log",
    params
  });
}

// /api/red/bag/game/income/v2/task
// 限时分红 获取任务列表
export function getGameIncomeV2Task(params) {
  return axiosGet({
    url: "/api/red/bag/game/income/v2/task",
    params
  });
}
// /api/red/bag/game/income/v2/task
// 限时分红 领取奖励
export function receiveGameIncomeV2Task(params) {
  return apiPost({
    url: "/api/red/bag/game/income/v2/task",
    params
  });
}

// /api/red/bag/level/magic/code
// 福袋兑换码
export function magicCode(params) {
  return apiGet({
    url: "/api/red/bag/level/magic/code",
    params
  });
}

// /api/magic/box/receive/red/bag/gift
// 魔盒礼包
export function redbagGift(params) {
  return apiPost({
    url: "/api/magic/box/receive/red/bag/gift",
    params
  });
}
// /api/red/bag/game/level/income/v2/config
// 红包瓜分2限时红包配置

export function receiveGameLevelincomev2config(params) {
  return apiGet({
    url: "/api/red/bag/game/level/income/v2/config",
    params
  });
}

// /api/red/bag/game/level/income/v2/receive
// 红包瓜分2限时红包领取

export function gameLevelIncomev2Receive(params) {
  return apiPost({
    url: "/api/red/bag/game/level/income/v2/receive",
    params
  });
}

// /api/red/bag/game/level/income/v2/log
// 获取瓜分红包2 限时津贴日志
export function getGameLevelincomev2log(params) {
  return axiosGet({
    url: "/api/red/bag/game/level/income/v2/log",
    params
  });
}

// "/api/red/bag/v2/level/config"
// 获取等级红包配置 v2
export function redBagLevelConfig_v2(params) {
  return apiGet({
    url: "/api/red/bag/v2/level/config",
    params
  });
}

// "/api/red/bag/v2/level"
// 领取红包
export function getRedBagLevel_v2(params) {
  return apiPost({
    url: "/api/red/bag/v2/level",
    params
  });
}
// "/api/red/bag/v2/level/money"
// 等级红包领取 v2
export function redBagLevelMoney_v2(params) {
  return apiGet({
    url: "/api/red/bag/v2/level/money",
    params
  });
}

// /api/red/bag/exclusive
// 获取专属等级红包列表
export function getRedBagExclusive(params) {
  return apiGet({
    url: "/api/red/bag/exclusive",
    params
  });
}

// /api/red/bag/exclusive/receive
// 领取专属等级红包
export function receiveExclusiveRed(params) {
  return apiPost({
    url: "/api/red/bag/exclusive/receive",
    params
  });
}

// /api/red/bag/status
// 获取集成红包领取状态
export function getRedBagStatus(params,headers) {
  return apiGet({
    url: "/api/red/bag/status",
    params,
    headers
  });
}



// WEBPACK FOOTER //
// ./src/api/hongbao/hongbaoh5.js